import React, { Fragment, useState } from 'react';
import { CloseCircleFilled } from '@ant-design/icons';
import { Alert, Tooltip } from 'antd';
import TickIcon from '../../../assets/images/tick-icon-filled.svg';
import ChangeEmailModal from './ChangeEmailModal';
import ChangeNumberModal from './ChangeNumberModal';
import MedicalDetails from './MedicalDetails';
import { CallIconColor, EmailIconColor } from '../../../utilities/resources';

function RightSection(props) {
  const { profileStepsCount, userDetails, profileStrength, verifyEmail } = props;
  const [visibleMobileChangePopup, setVisibleMobileChangePopup] = useState(false);
  const [visibleEmailChangePopup, setVisibleEmailChangePopup] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const handleMobileModal = () => {
    setVisibleMobileChangePopup(true);
    setCurrentStep(0);
  };

  const handleEmailModal = () => {
    setVisibleEmailChangePopup(true);
    setCurrentStep(0);
  };

  const mobileChangeStatus = (isChanged, status) => {
    console.log(isChanged);
    console.log(status);
  };

  return userDetails.users ? (
    <div className='profile_right fadeIn-up' style={{ animationDelay: '0.2s' }}>
      <div className='profile_body'>
        <ChangeEmailModal isModalVisible={visibleEmailChangePopup} setIsModalVisible={setVisibleEmailChangePopup} currentStep={currentStep} setCurrentStep={setCurrentStep} userDetails={userDetails} />
        <ChangeNumberModal
          isModalVisible={visibleMobileChangePopup}
          setIsModalVisible={setVisibleMobileChangePopup}
          mobileChangeStatus={mobileChangeStatus}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          userDetails={userDetails}
        />
        {/* {profileStrength.number === profileStepsCount ? null : (
          <div className='profile_bannerStyle'>
            <Alert banner message={userDetails.users.incompleteProfileMessage} />
          </div>
        )} */}
        <div className='heading_title profile_cards_title'>Contact Details</div>
        <div className='profileMatrixContainer'>
          <div className='profileMatrix fadeIn-up' style={{ animationDelay: '0.25s' }}>
            <img src={CallIconColor} />
            <div className='profileMatrixInner'>
              <p className='profile_title'>Phone</p>
              <Tooltip title='Verified'>{userDetails.users.isPhoneVerified ? <img src={TickIcon} alt='Tick Icon' className='profileStatusIcon' style={{ width: 18 }} /> : null}</Tooltip>
              <div className='profile_content'>
                <span>{userDetails.users.mobileNumber}</span>
                <div className='profile_actions'>
                  <span onClick={handleMobileModal}>Change</span>
                </div>
              </div>
            </div>
          </div>
          <div className='profileMatrix fadeIn-up' style={{ animationDelay: '0.4s' }}>
            <img src={EmailIconColor} />
            <div className='profileMatrixInner'>
              <p className='profile_title'>Email</p>
              <Tooltip title={userDetails.users.isEmailVerified ? 'Verified' : 'Verification Pending'}>
                {userDetails.users.isEmailVerified ? (
                  <img src={TickIcon} alt='Tick Icon' className='profileStatusIcon' style={{ width: 18 }} />
                ) : (
                  <CloseCircleFilled style={{ color: '#ffa500' }} className='profileStatusIcon' />
                )}
              </Tooltip>
              <div className='profile_content'>
                <span>{userDetails.users.email}</span>
                <div className='profile_actions'>
                  {userDetails.users.isEmailVerified ? null : (
                    <Fragment>
                      <span onClick={verifyEmail}>Verify Now</span>
                      <span style={{ color: '#575656', textDecoration: 'none', padding: '0 5px' }}>OR</span>
                    </Fragment>
                  )}
                  <span onClick={handleEmailModal}>Change</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <MedicalDetails userDetails={userDetails} />
      </div>
    </div>
  ) : null;
}

export default RightSection;
